var BUTTON_VARIANT;
(function (BUTTON_VARIANT) {
    BUTTON_VARIANT["PRIMARY"] = "primary";
    BUTTON_VARIANT["PRIMARY_LIGHT"] = "primary-light";
    BUTTON_VARIANT["SECONDARY"] = "secondary";
})(BUTTON_VARIANT || (BUTTON_VARIANT = {}));
export { BUTTON_VARIANT };
